import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import _styles from './styles.module.css';
import * as constants from '../../constants';

const FieldMessage = ({ intent, children, styles }: any) => {
  const className = cnames({
    [styles.errorMessage]: intent === constants.ERROR,
    [styles.successMessage]: intent === constants.SUCCESS,
    [styles.warningMessage]: intent === constants.WARNING,
    [styles.informationMessage]: intent === constants.INFORMATION,
    [styles.neutralMessage]: intent === constants.NEUTRAL,
  });

  return <div className={className}>{children}</div>;
};

(FieldMessage as any).propTypes = {
  intent: PropTypes.string,
  children: PropTypes.node.isRequired,
  styles: PropTypes.shape({}),
};

(FieldMessage as any).defaultProps = {
  intent: constants.INFORMATION,
  styles: _styles,
};

export default FieldMessage;
